/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Login_Toast_Failed_TitleInputs */

const en_auth_login_toast_failed_title = /** @type {(inputs: Auth_Login_Toast_Failed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign-in failed`)
};

/**
* | output |
* | --- |
* | "Sign-in failed" |
*
* @param {Auth_Login_Toast_Failed_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const auth_login_toast_failed_title = /** @type {((inputs?: Auth_Login_Toast_Failed_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Login_Toast_Failed_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_auth_login_toast_failed_title(inputs)
});